import './GraphicInstallationPage.scss';
import { useTranslation } from '../../../i18n/i18n';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InstallationGraph from '../../../components/installation/graph/InstallationGraph';
import { installationDataApi } from '../../../api/installation-data.api';
import { Spin } from 'antd';

type SiphonData = {
  privateSiphon: number;
  publicSiphon: number;
};

const GraphicInstallationPage = () => {
  const { installationUuid } = useParams<{ installationUuid: string }>();
  const { t } = useTranslation('installation-location', {
    keyPrefix: 'installationLocationDetail.installation.graphic',
  });
  const [siphonData, setSiphonData] = useState<SiphonData>({ privateSiphon: 0, publicSiphon: 0 });
  const [apiFetched, setApiFetched] = useState<boolean>(false);
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);
  const loading = !apiFetched || !imageLoaded;

  useEffect(() => {
    if (!installationUuid) return;

    const fetchTelemetry = async () => {
      try {
        const [publicData, privateData] = await Promise.all([
          installationDataApi.getLastPublicSewerLevel(installationUuid),
          installationDataApi.getLastPrivateSewerLevel(installationUuid),
        ]);

        setSiphonData({
          publicSiphon: publicData ?? 0,
          privateSiphon: privateData ?? 0,
        });
      } catch (error) {
        console.error('[GraphicInstallationPage] Failed to fetch telemetry:', error);
      } finally {
        setApiFetched(true);
      }
    };

    fetchTelemetry();
  }, [installationUuid]);

  return (
    <>
      <img src={'/assets/images/sifon.png'} style={{ display: 'none' }} onLoad={() => setImageLoaded(true)} alt="" />
      {loading ? (
        <div className={'GraphicInstallationPage GraphicInstallationPage--loading'}>
          <Spin size={'large'} />
        </div>
      ) : (
        <div className={'GraphicInstallationPage'}>
          <InstallationGraph percentage={siphonData.privateSiphon} title={t('private')} />
          <img className={'GraphicInstallationPage__img'} src={'/assets/images/sifon.png'} alt={t('siphonImg')} />
          <InstallationGraph percentage={siphonData.publicSiphon} title={t('public')} />
        </div>
      )}
    </>
  );
};

export default GraphicInstallationPage;
